<h1 mat-dialog-title>{{ 'material.compositeMaterial' | transloco }}</h1>

<mat-dialog-content>
  <app-composite-materials-overview #materialsTable [dataSource]="dataSource" [displayedColumns]="displayedColumns">
  </app-composite-materials-overview>
</mat-dialog-content>

<mat-dialog-actions>
  <button (click)="importMaterials(true)" mat-raised-button type="submit" color="primary"
    [disabled]="materialsTable.selectedMaterialIds.length === 0 || isDataExchangeSubRequest">
    {{ 'component.addWithTracking' | transloco }}</button>
  <button (click)="importMaterials(false)" mat-raised-button type="submit" color="primary"
    [disabled]="materialsTable.selectedMaterialIds.length === 0">
    {{ 'component.addWithoutTracking' | transloco }}</button>
  <button (click)="closeDialog()" mat-raised-button type="button">
    {{ 'common.buttons.cancel' | transloco }}</button>
</mat-dialog-actions>
